import lodash from 'lodash';

export function getExpectationsUploadedFilesCount(state) {

    const study = lodash.get(state, 'studyExpectations.allExpectedStudyDocuments', []);
    const staff = lodash.get(state, 'studyExpectations.allExpectedStaffDocuments', []);
    const expectationsToProcess = [study, staff];

    let expectations = [];
    for (const item of expectationsToProcess) {
        if (Array.isArray(item)) {
            expectations = [
                ...expectations,
                ...item
            ];
        } else {
            const itemValues = Object.values(item);
            const flattenValues = lodash.flatten(itemValues);
            expectations = [
                ...expectations,
                ...flattenValues
            ];
        }
    }

    const expectationsUploadedFiles =  expectations
        .filter(expectation => lodash.get(expectation, 'uploaded'))
        .map(expectationWithUpload => expectationWithUpload.uploaded);

    return lodash.flatten(expectationsUploadedFiles).length;
}